import { SeuConfigVersion } from '@seu-types';

export function isOutdated(
  key: string,
  version: number,
  latestVersionNr: number,
  allVersions: SeuConfigVersion[]
): boolean {
  if (version === latestVersionNr) {
    return false;
  }

  const versionsBetween = allVersions.filter(
    (v) => v.versionNr > version && v.versionNr <= latestVersionNr
  );

  return versionsBetween.some((v) => v.changedElements.includes(key));
}

export function getTabKeyByConfigKey(configKey: string): string {
  switch (configKey) {
    case 'globalSettings':
      return 'global-values';
    case 'emissionLimit':
      return 'global-values';
    case 'operationalExpenditures':
      return 'global-values';
    case 'inputStream':
      return 'operating-conditions';
    default:
      return 'components';
  }
}
